import { render, staticRenderFns } from "./RestorationMessages.vue?vue&type=template&id=372e7342&scoped=true&"
import script from "./RestorationMessages.vue?vue&type=script&lang=js&"
export * from "./RestorationMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "372e7342",
  null
  
)

export default component.exports